@import '../../../theme.scss';

.index-slogan {
    .MainContainer {
        width: $contentWidth;
        max-width: $contentMaxWidth;
        margin: 0 auto;
    }
    .BannerContainer {
        align-items: center;
        color: #fff;
        position: relative;
        height: 700px;
        .SloganContainer {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);

            @media (max-width: 992px) {
                word-wrap: break-word;
            }
            .Slogan {
                font-size: 30px;
                margin-bottom: 22px;
            }
            .SloganContent {
                font-size: 23px;
            }
            .MainLink {
                margin-top: 60px;
                a {
                    color: #fff;
                    display: inline-block;
                    line-height: 44px;
                    padding: 0 30px;
                    margin-right: 10px;
                    border: 1px solid #fff;
                    border-radius: 22px;
                    &:hover {
                        color: darken(#fff, 10%);
                        border-color: darken(#fff, 10%);
                        text-decoration: none;
                    }
                }
                a:hover {
                    background: #fff;
                    color: #7ba2ff;
                }
            }
        }
        .BannerIcon {
            position: absolute;
            right: 0;
            bottom: -50px;
            @media (max-width: 992px) {
                display: none;
            }
        }
    }
}
